import "react-toastify/dist/ReactToastify.css";

import {
    About,
    Home,
    Menu, PaymentFail, PaymentOk,
    Services
} from "./pages";
import {Cart, Footer, Header} from "./components";
import {Route, Routes} from "react-router-dom";

import {AnimatePresence} from "framer-motion";
import {ToastContainer} from "react-toastify";
import React, {useEffect} from "react";
import {useStateValue} from "./context/StateProvider";
import {fetchFoodData} from "./api/food";
import {fetchCategories} from "./api/category";
import {calculateCartTotal, fetchCartData} from "./utils/cart";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PublicOffer from "./components/PublicOffer";
import Cookies from "./components/Cookies";
import {fetchCookies} from "./utils/functions";
import {fetchSchedule} from "./api/cart";

function App() {
    const [
        {showCart, foodItems, cartItems, cookieAccept},
        dispatch,
    ] = useStateValue();

    useEffect(() => {
        fetchCategories(dispatch);
        fetchFoodData(dispatch);
        fetchCartData(foodItems, dispatch);
        fetchCookies(dispatch);
        fetchSchedule(dispatch);
    }, [dispatch]);
    useEffect(() => {
        foodItems &&
        cartItems.length > 0 &&
        calculateCartTotal(cartItems, foodItems, dispatch);
    }, [cartItems, foodItems, dispatch]);
    return (
        <AnimatePresence exitBeforeEnter>
            <ToastContainer/>
            <div className="w-screen h-auto min-h-[100vh] flex flex-col bg-primary">

                {showCart && <Cart/>}
                {!cookieAccept && <Cookies/>}
                <Header/>
                <main
                    className={"pt-20 md:pt-28 w-full"}
                    onClick={() => {
                    }}
                >
                    <Routes>
                        <Route path="/*" element={<Home/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/menu" element={<Menu/>}/>
                        <Route path="/services" element={<Services/>}/>
                        <Route path="/privacy_policy" element={<PrivacyPolicy/>}/>
                        <Route path="/public_offer" element={<PublicOffer/>}/>
                        <Route path="/payment/uniteller/ok" element={<PaymentOk/>}/>
                        <Route path="/payment/uniteller/fail" element={<PaymentFail/>}/>
                    </Routes>
                    <Footer/>
                </main>
            </div>
        </AnimatePresence>
    );
}

export default App;
